<dialog shEscapeDialog (shEscapePressed)="closeModal()" #shDialog class="sh-dialog-container">
  <div [ngClass]="style">
    @if (title) {
      <header class="sh-dialog__header">
        <h3 class="sh-dialog__header__title">{{ title }}</h3>
      </header>
    }
    <section class="sh-dialog__content">
      <ng-content></ng-content>
    </section>
    @if (actions) {
      <footer class="sh-dialog__footer">
        <div class="sh-action-group -sh-align-end">
          @for (actionItem of actions; track actionItem) {
            <sh-action-item [item]="actionItem" class="sh-action-group__item"></sh-action-item>
          }
        </div>
      </footer>
    }
    <button type="button" (click)="closeModal()" class="sh-pure-icon-button sh-dialog__close" aria-label="close">
      <svg sh-icon [name]="'close'" class="sh-icon-button__icon" aria-hidden="true"></svg>
    </button>
  </div>
</dialog>
